import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';
import { OrganisationBranchConnectionModel } from '../models/organisation/organisation.branch.connection.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrganisationBranchConnectionApiService extends ApiService {
  readonly resourcePath = 'organisation_branch_connections';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<OrganisationBranchConnectionModel>> {
    return this.restList<OrganisationBranchConnectionModel>(filters);
  }
  
  create(data:object){
    return this.restCreate<OrganisationBranchConnectionModel>(data);
  }

  get(id: string): Observable<OrganisationBranchConnectionModel> {
    return this.restRead<OrganisationBranchConnectionModel>(id);
  }
  
  update(id: string, data: object): Observable<OrganisationBranchConnectionModel> {
    return this.restUpdate<OrganisationBranchConnectionModel>(id, data);
  }

  getByOrganisation(id:string):Observable<HydraCollection<OrganisationBranchConnectionModel>> {
    return this.http.get<HydraCollection<OrganisationBranchConnectionModel>>(this.apiUrl + '/organisations/' + id + '/branches').pipe(
        map(response => new HydraCollection<OrganisationBranchConnectionModel>(response))
      );
  }
}
